/**
 * Integration pages.
 */
import { generateTechTask } from '@/helpers/generated-tech-task'
import { RouteGroup } from '@/types/routing-types'


export default [
    generateTechTask('Facebook Page', 'franchise-facebook-page', RouteGroup.FRANCHISE_MGMT)
]
